import React, { useCallback } from 'react'
import { useTheme } from 'styled-components'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Button } from '@dsny/dsny-component-library'
import { Tonality } from '@dsny/dsny-component-library'
import ModalActions from 'reducers/Modal'

export default function ShareReleaseModalEmptyState() {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()

  const onInviteClick = useCallback(() => {
    dispatch(ModalActions.toggleShareReleaseModal())
    dispatch(ModalActions.toggleInviteModal())
  }, [])

  return (
    <>
      <Tonality.UIHeading
        headingStyle="headline5"
        style={{ marginBottom: 12, display: 'flex' }}
        color={theme.colors.neutralW90}
      >
        {t('share-release.no-verified-connections-modal-title')}
      </Tonality.UIHeading>

      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW90}
        style={{
          marginBottom: 24,
          fontSize: 14,
          color: theme.colors.neutralW70
        }}
      >
        {t('share-release.no-verified-connections-modal-body')}{' '}
      </Tonality.UIText>

      <Button
        variant="primary"
        setting="player"
        mode="dark"
        onClick={onInviteClick}
        style={{ width: '100%' }}
      >
        {t('invite-connection.invite-a-connection')}
      </Button>
    </>
  )
}
